module.exports = __webpack_public_path__ + "static/media/winterweave-3.4afe61d0.jpg";